module.exports = __webpack_public_path__ + "img/anton-bengtsson.3e77a896.jpeg";